module.exports = __webpack_public_path__ + "static/woman-lamp-square.511eef52.jpg";